'use client'

import * as React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { TableRow, TableCell } from '@/components/ui/table'

interface ProcessorsTableSkeletonProps {
    rows?: number
}

/**
 * ProcessorsTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function ProcessorsTableSkeleton({ rows = 8 }: ProcessorsTableSkeletonProps) {
    return (
        <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
            <>
                {Array.from({ length: rows }, (_, index) => (
                    <TableRow key={index}>
                        {/* Select Checkbox */}
                        <TableCell className="w-10">
                            <Skeleton height={16} width={16} />
                        </TableCell>

                        {/* Type with Icon */}
                        <TableCell>
                            <div className="flex items-center gap-2">
                                <Skeleton height={24} width={24} circle />
                                <Skeleton height={16} width={80} />
                            </div>
                        </TableCell>

                        {/* Name */}
                        <TableCell>
                            <Skeleton height={16} width={140} />
                        </TableCell>

                        {/* Status Badge */}
                        <TableCell className="w-24">
                            <Skeleton height={20} width={60} borderRadius="0.375rem" />
                        </TableCell>

                        {/* ID */}
                        <TableCell className="w-32">
                            <Skeleton height={14} width={80} />
                        </TableCell>

                        {/* Created Date */}
                        <TableCell className="w-24">
                            <Skeleton height={14} width={70} />
                        </TableCell>

                        {/* Actions */}
                        <TableCell className="w-10">
                            <Skeleton height={32} width={32} borderRadius="0.25rem" />
                        </TableCell>
                    </TableRow>
                ))}
            </>
        </SkeletonTheme>
    )
}

